/* eslint-disable @typescript-eslint/naming-convention */
export enum SizeInBytes {
  MB_10 = 10 * 1024 * 1024,
}
